module.exports = __webpack_public_path__ + "static/img/jdg.ac436a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/products/jdg.png
// module id = FA8G
// module chunks = 0